"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicType = void 0;
var LogicType;
(function (LogicType) {
    LogicType["SYS_ELEMENT_NOW"] = "Now";
    LogicType["SYS_ELEMENT_VIEWER_DEVICE"] = "Viewer Device";
    LogicType["SYS_ELEMENT_VIEWER_MOBILE_DEVICE_OS"] = "Viewer Mobile Device OS";
})(LogicType = exports.LogicType || (exports.LogicType = {}));
//# sourceMappingURL=logicTypes.js.map